<template>
  <tr>
    <td>{{ mentor.nombre }}</td>
    <td>{{ mentor.apellido }}</td>
  </tr>
</template>

<script>
export default {
  name: 'MentoresListaItem',
  components: {
  },
  props: ['mentor'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
  }
}
</script>
